import { createLayerComponent } from "@react-leaflet/core";
import type { GridLayer } from "leaflet";
import { leafletLayer } from "protomaps-leaflet";

export const BASEMAP_URL =
  "https://assets.imoova.com/basemap/protomaps-v4-20260331.pmtiles";

const ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

export const BasemapLayer = createLayerComponent<GridLayer, object>(
  (_props, context) => ({
    instance: leafletLayer({
      url: BASEMAP_URL,
      flavor: "light",
      lang: "en",
      attribution: ATTRIBUTION,
    }) as unknown as GridLayer,
    context,
  }),
);
